import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';

import { toast } from 'react-toastify';
import { useField } from 'formik';

export default function Dropzone({
  name,
  placeholder,
  config,
}) {
  const [field,, helpers] = useField(name);
  const onDrop = useCallback((acceptedFiles) => {
    helpers.setValue(field.value.concat(acceptedFiles));
  }, [field]);

  const onDropRejected = useCallback((rejectedFiles) => {
    rejectedFiles.forEach((file) => {
      toast.error(`File "${ file.file.name }", error: ${ file.errors[0].message }`);
    });
  }, [field]);

  const { getRootProps, getInputProps } = useDropzone({ onDrop, onDropRejected, ...config });

  return (
    <div className='dropzone' {...getRootProps()}>
      <input {...getInputProps()} />
      <p>{placeholder}</p>

      {field.value.length > 0 && (
        <div className='dropzone__list'>
          Uploaded files:
          <ul>
            {field.value.map((file) => (
              <li key={file.name}>
                <strong>{file.name}</strong>
                {' '}
                <small>
                  Type:
                  {' '}
                  {file.type}
                </small>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

Dropzone.defaultProps = {
  placeholder: 'Drop',
  config: {},
};

Dropzone.propTypes = {
  name: PropTypes.string.isRequired,
  config: PropTypes.object,
  placeholder: PropTypes.string,
};
